export default {
    ADMIN: 'ADMIN',
    STOREFRONT: 'STOREFRONT',
};
